import { Chip, Stack } from '@mui/material';
import {
  describeBasis,
  TIME_AXIS_HINT,
  TIME_AXIS_LABEL,
  VALUE_METRIC_HINT,
  VALUE_METRIC_LABEL,
  VOLUME_UNIT_HINT,
  VOLUME_UNIT_LABEL,
  type MetricBasis,
} from '@/lib/metricBasis';

/**
 * Podstawa metryki pokazana PRZY LICZBIE, a nie w przypisie na dole strony.
 *
 * Powód jest konkretny, nie estetyczny: różnica między wartością katalogową a kwotą pobraną
 * jest niejednorodna (szkoły z promocją ok. 1,49×, bez promocji 1,00×), więc zmienia RANKING,
 * nie tylko poziom liczb. Ranking bez podanej podstawy jest nieinterpretowalny — i właśnie
 * na nim opierają się rekomendacje wyjazdowe.
 *
 * Znaczniki są celowo małe i wyciszone: mają towarzyszyć liczbie, nie konkurować z nią.
 */
export function MetricBasisChips({ basis, size = 'small' }: { basis: MetricBasis; size?: 'small' | 'medium' }) {
  if (!basis.value && !basis.volume && !basis.time) return null;

  return (
    <Stack
      direction="row"
      spacing={0.5}
      useFlexGap
      sx={{ flexWrap: 'wrap', alignItems: 'center' }}
      aria-label={`Podstawa metryki: ${describeBasis(basis)}`}
    >
      {basis.value ? (
        <Chip
          size={size}
          variant="outlined"
          label={VALUE_METRIC_LABEL[basis.value]}
          title={VALUE_METRIC_HINT[basis.value]}
        />
      ) : null}
      {basis.volume ? (
        <Chip
          size={size}
          variant="outlined"
          label={VOLUME_UNIT_LABEL[basis.volume]}
          title={VOLUME_UNIT_HINT[basis.volume]}
        />
      ) : null}
      {basis.time ? (
        <Chip
          size={size}
          variant="outlined"
          label={TIME_AXIS_LABEL[basis.time]}
          title={TIME_AXIS_HINT[basis.time]}
        />
      ) : null}
    </Stack>
  );
}
